import packageConfig from '../package.json'

//
// only pages should be imported and used here
// http://bradfrost.com/blog/post/atomic-web-design/
//

let routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/HomePage')
  },
  {
    path: '/collection/:collection?',
    name: 'Collection',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/CollectionPage')
  },
  {
    path: '/product/:product?',
    name: 'Product',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/ProductPage')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/AboutPage')
  },
  {
    path: '/mensch',
    name: 'Mensch',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/MenschPage')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/ContactPage')
  },
  {
    path: '/women',
    name: 'Women',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/WomenPage')
  },
  {
    path: '/women-archive',
    name: 'WomenArchive',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/WomenArchivePage')
  },
  {
    path: '/men',
    name: 'Men',
    component: () => import(/* webpackChunkName: "page-home" */ './pages/MenPage')
  }
]

//
// System routes
//
if (!packageConfig.multilanguage || packageConfig.multilanguage === 'false') {
  // no multilanguage
  routes = routes.concat([
    {
      // matches /anyroute (if not found) and redirects it to /
      path: '*',
      redirect: '/'
    }
  ])
}
export default routes
